import { createApp } from "vue";
import Configurator from "./components/Configurator.vue";

document.addEventListener("DOMContentLoaded", () => {
  const configuratorContainer = document.getElementById("amprod-configurator");

  if (!configuratorContainer)
    return console.warn("Configurator container not found");

  // Mount the Configurator component directly
  const app = createApp(Configurator, {
    productPartNumber: configuratorContainer.dataset.productPartNumber || "",
    baseUrl: window.amprodConfiguratorData?.apiBaseUrl || "",
  });

  // Mount the component to the DOM
  app.mount(configuratorContainer);
});
